/**
 * 环境变量
 */
// 全象或者青云学院
export const isQx: boolean = true; // true 全象 false 青云学院
// 本地
// export const devBaseUrl: string = "http://127.0.0.1:10002";
export const devBaseUrl: string = "http://192.168.27.7";
// export const devBaseUrl: string = "http://learning.quanxiangyun.com:31172";
// 测试
export const testBaseUrl: string = "http://learning.quanxiangyun.com:31172";
// 生产
export const proBaseUrl: string = "http://learning.quanxiangyun.com:31172";
// 全象-本地
// export const devQxBaseUrl: string = "http://learning.local"
// export const devQxBaseUrl: string = "http://192.168.27.7"
export const devQxBaseUrl: string = "/e-learning"
// export const devQxBaseUrl: string = "http://127.0.0.1:10002";
// 全象-测试
// 测试
// export const testQxBaseUrl: string = "http://192.168.27.7";
// 正式
export const testQxBaseUrl: string = "https://partner.quanxiangyun.com/qingcloud/learning/e-learning";
// export const testQxBaseUrl: string = "http://192.168.0.11:10020";
// export const testQxBaseUrl: string = "http://qingcloud.ela.com";
// 全象-生产
// 测试
// export const proQxBaseUrl: string = "http://192.168.27.7";
// 生产
export const proQxBaseUrl: string = "https://partner.quanxiangyun.com/qingcloud/learning/e-learning";
// export const proQxBaseUrl: string = "http://192.168.0.11:10020";
// export const proQxBaseUrl: string = "https://partner.quanxiangyun.com/qingcloud/learning";
// export const proQxBaseUrl: string = "http://139.198.14.42";

// appid
export const appid: string = "10002";
